import React from 'react';
import { Modal, Button, Grid, Row, Col } from 'react-bootstrap';

const ResubscribeModal = props => (
  <Modal show={props.show} className="fullwidth-modal reactivate-modal">
    <Grid fluid>
      <Modal.Header>
        <Row>
          <Col xs={4} md={1}>
            <div className="meet-litpog" />
          </Col>
          <Col xs={6} md={10} />
        </Row>
      </Modal.Header>
    </Grid>
    <Modal.Body>
      <div className="fullheight">
        <h1 className="reactivate-text">We'd love to reinstate your access!</h1>
        <p className="reactivate-text-p">Click below to regain access.</p>
        <div className="simple-submit reactivate-sm">
          <Button onClick={props.handleResubscribe}>Reactivate my subscription</Button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
);

export default ResubscribeModal;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Exercises/ResubscribeModal.js